













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { irRmbTableMap } from '@/common/constant.js';

@Component({
  components: {}
})
class RMBIRBitableReport extends Vue {
  irRmbTable: string = '';

  created() {
    this.irRmbTable = irRmbTableMap[window.location.host];
  }
}
export default RMBIRBitableReport;
